<template>
  <div class="Aviso">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'Aviso'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <headNav :activeNav="'Aviso'"></headNav>
      </div>

      <div class="rapi_home_banner">
      </div>

      <div class="arrecrediayuda_head">
          <div class="arrecrediayuda_hmg">
            <div class="arrecrediayuda_hmg_v">
              <img src="../assets/img/arrecrediayuda_hmg_1.webp" alt="">
            </div>
          </div>
          <div class="arrecrediayuda_htitle">Preguntas frecuentes</div>
      </div>

      <div class="arrecrediayuda_don">
        <div class="arrecrediayuda_dontitle">Preguntas sobre solicitud del préstamo</div>
        <div class="arrecrediayuda_donlist">
          <div style="padding-top:40px">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item  :name="1">
                <template slot="title">
                  <transition name="slide-fade">
                    <div class="collapseDiv" :class="activeNames.indexOf(1)>-1?'activeTitle':''">
                      <p>¿Cómo solicitar un préstamo?</p>
                      <i v-if="activeNames.indexOf(1)==-1" class="el-icon-caret-bottom"></i>
                      <i v-if="activeNames.indexOf(1)>-1" class="el-icon-caret-top"></i>
                    </div>
                  </transition>
                </template>
                <div class="collapseCont">Descarga la aplicación en Google Play, regístrate con tu número de teléfono personal, selecciona el monto que deseas solicitar y completa la información requerida para finalizar la solicitud.</div>
              </el-collapse-item>
              <el-collapse-item :name="2">
                <template slot="title">
                  <div class="collapseDiv" :class="activeNames.indexOf(2)>-1?'activeTitle':''">
                    <p>¿Qué documentos se necesitan para solicitar un préstamo?</p>
                    <i v-if="activeNames.indexOf(2)==-1" class="el-icon-caret-bottom"></i>
                    <i v-if="activeNames.indexOf(2)>-1" class="el-icon-caret-top"></i>
                  </div>
                </template>
                <div class="collapseCont">
                  Solo requerimos tu identificación oficial y los datos de tu cuenta bancaria para recibir el dinero.
                </div>
              </el-collapse-item>
              <el-collapse-item :name="3">
                <template slot="title">
                  <div class="collapseDiv" :class="activeNames.indexOf(3)>-1?'activeTitle':''">
                    <p>¿Puedo solicitar préstamo a plazos?</p>
                    <i v-if="activeNames.indexOf(3)==-1" class="el-icon-caret-bottom"></i>
                    <i v-if="activeNames.indexOf(3)>-1" class="el-icon-caret-top"></i>
                  </div>
                </template>
                <div class="collapseCont">
                  Actualmente, nuestra plataforma ofrece préstamos a múltiples plazos, lo que reduce tu presión de pago y aumenta el monto aprobable.  Puedes consultar tu límite disponible seleccionando la opción "Múltiples plazos" en la página de inicio de la app.
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>

      <div class="arrecrediayuda_don">
        <div class="arrecrediayuda_dontitle">Preguntas sobre transferencia del préstamo</div>
        <div class="arrecrediayuda_donlist">
          <div style="padding-top:40px">
            <el-collapse v-model="activeNamesT" @change="handleChange">
              <el-collapse-item  :name="1">
                <template slot="title">
                  <transition name="slide-fade">
                    <div class="collapseDiv" :class="activeNamesT.indexOf(1)>-1?'activeTitle':''">
                      <p>¿Cuándo se recibe el dinero?</p>
                      <i v-if="activeNamesT.indexOf(1)==-1" class="el-icon-caret-bottom"></i>
                      <i v-if="activeNamesT.indexOf(1)>-1" class="el-icon-caret-top"></i>
                    </div>
                  </transition>
                </template>
                <div class="collapseCont">
                  El desembolso es normalmente instantáneo, pero puede tardar 15-30 minutos por mantenimiento bancario o días festivos.
                </div>
              </el-collapse-item>
              <el-collapse-item :name="2">
                <template slot="title">
                  <div class="collapseDiv" :class="activeNamesT.indexOf(2)>-1?'activeTitle':''">
                    <p>¿Qué hacer si no recibo el dinero tras la aprobación?</p>
                    <i v-if="activeNamesT.indexOf(2)==-1" class="el-icon-caret-bottom"></i>
                    <i v-if="activeNamesT.indexOf(2)>-1" class="el-icon-caret-top"></i>
                  </div>
                </template>
                <div class="collapseCont">
                  Si no recibes el dinero en 24 horas, contacta a nuestro servicio al cliente por teléfono o WhatsApp.
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>

      <div class="arrecrediayuda_don">
        <div class="arrecrediayuda_dontitle">Preguntas sobre pagar el préstamo</div>
        <div class="arrecrediayuda_donlist">
          <div style="padding-top:40px">
            <el-collapse v-model="activeNamesR" @change="handleChange">
              <el-collapse-item  :name="1">
                <template slot="title">
                  <transition name="slide-fade">
                    <div class="collapseDiv" :class="activeNamesR.indexOf(1)>-1?'activeTitle':''">
                      <p>¿Cómo pagar?</p>
                      <i v-if="activeNamesR.indexOf(1)==-1" class="el-icon-caret-bottom"></i>
                      <i v-if="activeNamesR.indexOf(1)>-1" class="el-icon-caret-top"></i>
                    </div>
                  </transition>
                </template>
                <div class="collapseCont">
                  Aceptamos pagos en línea (transferencia).  Los pagos presenciales tienen comisiones adicionales, por lo que recomendamos el método en línea.
                </div>
              </el-collapse-item>
              <el-collapse-item :name="2">
                <template slot="title">
                  <div class="collapseDiv" :class="activeNamesR.indexOf(2)>-1?'activeTitle':''">
                    <p>¿Dónde veo la fecha de pago?</p>
                    <i v-if="activeNamesR.indexOf(2)==-1" class="el-icon-caret-bottom"></i>
                    <i v-if="activeNamesR.indexOf(2)>-1" class="el-icon-caret-top"></i>
                  </div>
                </template>
                <div class="collapseCont">
                  Consulta la información de pago (monto, fecha, códigos promocionales) en la app. Si no aparece, contacta al servicio al cliente.
                </div>
              </el-collapse-item>
              <el-collapse-item :name="3">
                <template slot="title">
                  <div class="collapseDiv" :class="activeNamesR.indexOf(3)>-1?'activeTitle':''">
                    <p>¿Dónde encuentro la referencia de pago?</p>
                    <i v-if="activeNamesR.indexOf(3)==-1" class="el-icon-caret-bottom"></i>
                    <i v-if="activeNamesR.indexOf(3)>-1" class="el-icon-caret-top"></i>
                  </div>
                </template>
                <div class="collapseCont">
                  El código de pago (cuenta bancaria destinada a tu préstamo) aparece en la app. No uses referencias de terceros para evitar fraudes.  Si no lo ves, contáctanos.
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/Aviso.scss";

export default {
    name: "Aviso",
    components: { headNav, footPage },
    data() {
      return {
        scroll: 0,
        scrollseek: 1,
        activeNames:[],
        activeNamesT: [],
        activeNamesR: [],
      }
    },
    mounted(){
      document.documentElement.scrollTop = 0;
      if(this.$route.query.seek){
        this.scrollseek = this.$route.query.seek;
        if(this.scrollseek == 1){
          document.documentElement.scrollTop = 470;
        } else if(this.scrollseek == 2){
          document.documentElement.scrollTop = 922;
        } else if(this.scrollseek == 3){
          document.documentElement.scrollTop = 1307;
        }
      }
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
        console.log(this.scroll)
      },
      handleChange() {

      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
  .title p span {
    border-bottom: 3px solid #4e67f1;
  }
  .rapi_home_banner{
    width: 100%;
    height: 248px;
    position: relative;
    overflow: hidden;
    z-index: 2;
  }
  .arrecrediayuda_head{
    width: 100%;
    height: 358px;
  }
  .arrecrediayuda_hmg{
    width: 151px;
    height: 154px;
    margin: 0 auto;
    position: relative;
  }
  .arrecrediayuda_hmg_v{
    width: 151px;
    height: 173px;
  }
  .arrecrediayuda_htitle{
    width: 100%;
    height: 48px;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 48px;
    color: #262A48;
    line-height: 48px;
    text-align: center;
    font-style: normal;
  }
  .arrecrediayuda_don{
    width: 1320px;
    height: auto;
    border-radius: 40px;
    box-sizing: border-box;
    border: 1px solid #707387;
    padding: 80px 80px 40px 80px;
    margin: 0 auto 80px auto;
  }
  .arrecrediayuda_dontitle{
    width: 100%;
    height: 28px;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 28px;
    color: #262A48;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .collapseDiv{
    background: #f8f8f8;
    width: 100%;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    border-radius: 4px;
  }
  .arrecrediayuda_don .el-collapse-item__arrow{
    display: none;
  }
  .arrecrediayuda_don .el-collapse-item__header{
    border-bottom: none;
  }
  .arrecrediayuda_don .el-collapse-item{
    margin-bottom: 18px;
  }
  .arrecrediayuda_don .el-collapse{
    border-top: none;
  }
  .activeTitle{
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .collapseCont{
    background: #f8f8f8;
    padding: 20px 33px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .rapi_home_banner {
      height: 150px;
    }
    .arrecrediayuda_head {
      height: auto;
      box-sizing: border-box;
      padding: 40px 16px;
    }
    .arrecrediayuda_hmg {
      width: 100px;
      height: auto;
    }
    .arrecrediayuda_hmg_v {
      width: 100px;
      height: auto;
    }
    .arrecrediayuda_htitle {
      font-size: 28px;
      line-height: 36px;
      margin-top: 16px;
    }
    .arrecrediayuda_don {
      width: 94vw;
      max-width: 100%;
      box-sizing: border-box;
      padding: 24px 16px;
      border-radius: 16px;
      margin: 0 auto 20px auto;
    }
    .arrecrediayuda_dontitle {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 20px;
    }
    .collapseDiv {
      padding: 12px 16px;
      font-size: 16px;
      flex-wrap: wrap;
    }
    .collapseDiv p {
      width: calc(100% - 30px);
      margin: 0;
    }
    .collapseCont {
      padding: 16px;
      font-size: 14px;
      line-height: 22px;
    }
  }
</style>

